import { Box } from 'theme-ui'

import { BackgroundColorTypes } from 'src/theme/adSales/colors'
import Breadcrumb, { BreadcrumbItem } from 'src/components/common/breadcrumb/Breadcrumb'
import Type from 'src/components/gel/Type'

export interface MinimalHeaderProps {
  breadcrumbs?: BreadcrumbItem[]
  title: string
  backgroundColor: BackgroundColorTypes
}

const MinimalHeader = ({ breadcrumbs, title, backgroundColor }: MinimalHeaderProps) => {
  return (
    <Box sx={{ pb: [6, null, 6, 11], background: backgroundColor }}>
      <Box
        variant="layout.wideContainer"
        sx={{ display: ['block', null, 'block'], pb: [2, null, 2, 9] }}
      >
        <Breadcrumb crumbs={breadcrumbs} textColor="colors.tertiary" />
      </Box>
      <Box variant="layout.wideContainer" sx={{ px: [4, 4, 4, 4, null] }}>
        {title && (
          <Type variant="HeadlineSerif" sx={{ mb: 6, color: 'white' }}>
            {title}
          </Type>
        )}
      </Box>
    </Box>
  )
}

export default MinimalHeader
